import ApiService from '@/core/services/api.service'
import { formatDBDate, getCurrentDate } from '@/utils/date'

const buildReportFilterParams = params => {
  return {
    startDate: formatDBDate(params.startDate) || undefined,
    endDate: formatDBDate(params.endDate) || undefined,
    storeId: params.storeId || undefined,
    billType: params.billType || undefined,
    billNumber: params.billNumber || undefined,
  }
}

const BillRevenueReportService = {
  /**
   * Fetch stores by user
   */
  async fetchStoresByUser() {
    const response = await ApiService.get('/stores/getStores')
    return response.data.data || []
  },

  /**
   * Fetch bill revenue report list
   */
  async fetchReportList(params) {
    const queryParams = {
      ...buildReportFilterParams(params),
      page: params.page || 1,
      limit: params.limit || 10,
    }

    const response = await ApiService.query('/v1/bill-revenue-reports', { params: queryParams })
    return response.data.data
  },

  /**
   * Fetch bill revenue report summary
   */
  async fetchReportSummary(params) {
    const queryParams = buildReportFilterParams(params)

    const response = await ApiService.query('/v1/bill-revenue-reports/summary', {
      params: queryParams,
    })
    return response.data.data
  },

  async fetchSyncState() {
    const response = await ApiService.query('/v1/sync-states/latest', {
      params: { type: 'bill_revenue_report' },
    })
    return response.data.data
  },

  async syncData() {
    const response = await ApiService.post('/v1/bill-revenue-reports/sync')
    return response.data.data
  },

  async exportExcel(params) {
    const queryParams = buildReportFilterParams(params)

    const response = await ApiService.get('/v1/bill-revenue-reports/export', {
      params: queryParams,
      responseType: 'blob',
    })

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `bao_cao_lai_lo_${getCurrentDate('YYYYMMDD_HHmmss')}.xlsx`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  },
}

export default BillRevenueReportService
